'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _util = require('../../../../util');

var _util2 = _interopRequireDefault(_util);

var _select = require('../../../../select');

var _select2 = _interopRequireDefault(_select);

var _button = require('../../../../button');

var _button2 = _interopRequireDefault(_button);

var _treeSelect = require('../../../../tree-select');

var _treeSelect2 = _interopRequireDefault(_treeSelect);

require('./index.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var MultiSelectDropdown = function (_M$BaseComponent) {
  _inherits(MultiSelectDropdown, _M$BaseComponent);

  function MultiSelectDropdown(props) {
    _classCallCheck(this, MultiSelectDropdown);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(MultiSelectDropdown).call(this, props));

    Object.assign(_this.state, {
      value: props.value && props.value.slice() || []
    });
    return _this;
  }

  _createClass(MultiSelectDropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      //FIXME 直接调用会使得页面滚动到顶部
      this.setTimeout(function () {
        _this2.refs.select.focusInput();
      }, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var baseCls = 'multi-select-dropdown';
      var _props = this.props;
      var selectProps = _props.selectProps;
      var type = _props.type;
      var value = this.state.value;

      var SelectComponent = void 0;
      switch (type) {
        case 'multiSelect':
          SelectComponent = _select2.default;
          break;
        case 'treeMultiSelect':
          SelectComponent = _treeSelect2.default;
          break;
      }
      return _react2.default.createElement(
        'div',
        { className: baseCls },
        _react2.default.createElement(
          'div',
          { ref: 'selectWrapper', className: baseCls + '__select-wrapper' },
          SelectComponent && _react2.default.createElement(SelectComponent, _extends({ ref: 'select'
          }, selectProps, {
            className: baseCls + '__select',
            triggerClassName: baseCls + '__trigger',
            getPopupContainer: function getPopupContainer() {
              return (0, _reactDom.findDOMNode)(_this3.refs.selectWrapper);
            },
            multiple: true,
            value: value,
            onChange: this._onChange,
            onSelect: this._onSelect }))
        ),
        _react2.default.createElement(
          'div',
          { className: baseCls + '__operation' },
          _react2.default.createElement(_button2.default, { className: baseCls + '__btn',
            type: 'default',
            size: 'xsmall',
            label: '取消',
            onClick: this._cancel }),
          _react2.default.createElement(_button2.default, { className: baseCls + '__btn',
            type: 'primary',
            size: 'xsmall',
            label: '确定',
            onClick: this._confirm })
        )
      );
    }
  }, {
    key: '_onChange',
    value: function _onChange(value) {
      this.setState({ value: value });
    }
  }, {
    key: '_cancel',
    value: function _cancel() {
      var onCancel = this.props.onCancel;

      onCancel && onCancel(this.state.value);
    }
  }, {
    key: '_confirm',
    value: function _confirm() {
      var onConfirm = this.props.onConfirm;

      onConfirm && onConfirm(this.state.value);
    }
  }, {
    key: '_onSelect',
    value: function _onSelect(v, e) {
      // FIXME 现象：设置了select的选中后清空关键字时，当输入关键字搜索并选中某项时，
      // 造成关键字被清空，触发了再次搜索，之前的选项被移出了DOM结构，触发了关闭表头筛选框
      // 这里处理为阻止冒泡来避免上述问题
      e.stopPropagation();
    }
  }]);

  return MultiSelectDropdown;
}(_util2.default.BaseComponent);

exports.default = MultiSelectDropdown;